import React from "react";
// Same UMD/CJS interop quirk as react-switch: the default import comes through
// as the `{ default, __esModule }` wrapper under Vite's optimizer. Unwrap it.
import ReactLoader from "react-loader-spinner";
const Loader = ReactLoader.default || ReactLoader;

export default function LegacyFitnessSpinner({on, children}) {
  if(on) {
    return (
    	<div className="text-center">
	    	<div style={{display: "block", margin: "auto", width: "130px"}}>
		      <Loader
		        type="Circles"
		        color="#00BFFF"
		        height={120}
		        width={120}
		        timeout={30000}
		      />
		    </div>
	    </div>);
  }
  return children;
}